import JourneyWithNextSchedule from '../../JourneyWithNextSchedule';
import { JourneyActionPayload, getCurrentSchedule } from '..';
import { Button } from '../style';
import Modal from '../../../pages/Journey/ContentExams/Modal';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store';
import { ISchedules } from '../../../../services/journey.service';

export const ExamAvailableSmall = ({ journey }: JourneyActionPayload) => {
  const [open, setOpen] = useState(false);
  const {
    journey: { files }
  } = useSelector((state: RootState) => state);

  const handleOpen = () => {
    setOpen(!open);
  };

  const currentSchedule = getCurrentSchedule(journey);
  return (
    <>
      <JourneyWithNextSchedule
        journey={journey}
        schedule={currentSchedule as ISchedules}
        actionButton={
          <Button variant="contained" onClick={() => handleOpen()}>
            Ver exame
          </Button>
        }
      />
      <Modal
        openCloseController={open}
        onCloseHandler={() => {
          handleOpen();
        }}
        infoType={'EXAM'}
        dataFiles={files}
      />
    </>
  );
};
